/* globals AUTH,mobile */

import $ from 'jquery';
import _ from 'underscore';

import TastypieCollection from 'core/collections/tastypie';


export default TastypieCollection.extend({
  constructor: function () {
    // Define the params object off of the prototype chain
    this.params = mobile ? _.extend({
      username: window.localStorage.getItem('USERNAME'),
      api_key: window.localStorage.getItem('API_KEY')
    }, AUTH) : {};

    // Call the original constructor
    TastypieCollection.apply(this, arguments);
  },

  url: function () {
    var result = this.urlRoot;
    if (!_.isEmpty(this.params)) {
      result = result + ('?' + $.param(this.params));
    }
    return result;
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/collections/tracker.js
// module id = 10
// module chunks = 0